export const STORE_ROLES = 'STORE_ROLES'
export const STORE_PARTY_ROLES = 'STORE_PARTY_ROLES'
export const UPDATE_USER_IN_LIST = 'UPDATE_USER_IN_LIST'
export const STORE_PARTY_ID = 'STORE_PARTY_ID'
export const CLEAN_PARTY_ID = 'CLEAN_PARTY_ID'
export const STORE_ORGANIZATION_ID = 'STORE_ORGANIZATION_ID'
export const CLEAN_ORGANIZATION_ID = 'CLEAN_ORGANIZATION_ID'
export const STORE_ENDPOINTS = 'STORE_ENDPOINTS'
export const STORE_USER_ENDPOINTS = 'STORE_USER_ENDPOINTS'
export const STORE_CLIENT_ROLES = 'STORE_CLIENT_ROLES'
export const STORE_SELECTED_CLIENT_ROW = 'STORE_SELECTED_CLIENT_ROW'
export const STORE_SELECTED_ORGANIZATION_ROW = 'STORE_SELECTED_ORGANIZATION_ROW'
export const UPDATE_ORGANIZATION_IN_LIST = 'UPDATE_ORGANIZATION_IN_LIST'
export const STORE_SELECTED_ENDPOINTS = 'STORE_SELECTED_ENDPOINTS'
export const UPDATE_TINY_URLS_IN_LIST = 'UPDATE_TINY_URLS_IN_LIST'
export const STORE_TINY_URLS = 'STORE_TINY_URLS'
export const UNBAN_USER_FROM_PROPERTY = 'UNBAN_USER_FROM_PROPERTY'
export const STORE_TRANSACTION_LOGS = 'STORE_TRANSACTION_LOGS'
export const STORE_USER_WALLET = 'STORE_USER_WALLET'
export const UPDATE_MORPHEUS_LOGS = 'UPDATE_MORPHEUS_LOGS'
export const FETCH_SAVED_SEARCHES_SUCCESS = 'FETCH_SAVED_SEARCHES_SUCCESS'
export const CREATE_SAVED_SEARCH_SUCCESS = 'CREATE_SAVED_SEARCH_SUCCESS'
export const UPDATE_SAVED_SEARCH_SUCCESS = 'UPDATE_SAVED_SEARCH_SUCCESS'
export const DELETE_SAVED_SEARCH_SUCCESS = 'DELETE_SAVED_SEARCH_SUCCESS'
export const UPDATE_COMMUNICATIONS = 'UPDATE_COMMUNICATIONS'

// Schedule (events/venues)
export const CLEAR_VENUE_TEMPLATES = 'CLEAR_VENUE_TEMPLATES'
export const UPDATE_VENUE_TEMPLATES = 'UPDATE_VENUE_TEMPLATES'
export const UPDATE_VENUE_TEMPLATE_IN_LIST = 'UPDATE_VENUE_TEMPLATE_IN_LIST'
export const CLEAR_EVENT_TEMPLATES = 'CLEAR_EVENT_TEMPLATES'
export const UPDATE_EVENT_TEMPLATE_IN_LIST = 'UPDATE_EVENT_TEMPLATE_IN_LIST'
export const ADD_FORM_VENUE_TEMPLATES_FILTER = 'ADD_FORM_VENUE_TEMPLATES_FILTER'
export const ADD_FORM_EVENT_TEMPLATES_FILTER = 'ADD_FORM_EVENT_TEMPLATES_FILTER'
export const CLEAR_EVENTS = 'CLEAR_EVENTS'
export const UPDATE_EVENT_IN_LIST = 'UPDATE_EVENT_IN_LIST'
export const STORE_PARENT_EVENT = 'STORE_PARENT_EVENT'
export const CLEAR_PARENT_EVENT = 'CLEAR_PARENT_EVENT'
export const CLEAR_VENUES = 'CLEAR_VENUES'
export const UPDATE_VENUE_IN_LIST = 'UPDATE_VENUE_IN_LIST'
export const UPDATE_BULK_UPDATED_VENUE_COUNT = 'UPDATE_BULK_UPDATED_VENUE_COUNT'
export const CLEAR_BULK_UPDATED_VENUE_COUNT = 'CLEAR_BULK_UPDATED_VENUE_COUNT'
export const UPDATE_BULK_UPDATED_EVENT_COUNT = 'UPDATE_BULK_UPDATED_EVENT_COUNT'
export const CLEAR_BULK_UPDATED_EVENT_COUNT = 'CLEAR_BULK_UPDATED_EVENT_COUNT'
